export const profileTab = [
  {
    name: "My Profile",
    path: "/my-profile",
  },
  {
    name: "Shipping Preferences",
    path: "/shipping-preferences",
  },
  {
    name: "Billing Address",
    path: "/billing-address",
  },
  {
    name: "Sign Out",
    logout: true,
  },
];
